<template>
  <v-card>
    <v-toolbar color="#262D46" dark>
      <v-btn icon dark @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title class="titleText">{{ title }}</v-toolbar-title>
    </v-toolbar>
    <v-col cols="12">
      <v-row v-if="!qr" justify="center" class="pt-10">
        <v-avatar size="160">
          <v-img :src="icon"></v-img>
        </v-avatar>
      </v-row>
      <v-row justify="center" class="pt-3 title">
        {{ name }}
      </v-row>
      <div v-if="qr">
        <v-row justify="center" class="pt-5">
          <img :src="qr" width="126" height="126" aspect-ratio="1" class="imgQrcode" />
        </v-row>
        <v-row justify="center">
          <p class="qrUrl pt-4">{{ qrUrl }}</p>
          <v-tooltip top v-model="copyTooltip">
            <template v-slot:activator="{ on }">
              <v-icon class="copyIcon" small @click="copyUrl()" v-on="on"> mdi-content-copy </v-icon>
            </template>
            <span>{{ $t("copied") }}</span>
          </v-tooltip>
          <div id="urlDiv"></div>
        </v-row>
      </div>
    </v-col>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    qr: {
      type: String,
      default: "",
    },
    qrUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      copyTooltip: false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    copyUrl() {
      this.copyTooltip = true;

      const div = document.getElementById("urlDiv");
      const textarea = document.createElement("textarea");
      div.appendChild(textarea);
      textarea.value = this.qrUrl;

      if (
        window.navigator.userAgent.toString().includes("iPhone") ||
        window.navigator.userAgent.toString().includes("iPad")
      ) {
        const range = document.createRange();
        range.selectNodeContents(textarea);
        let s = window.getSelection();
        if (s) {
          s.removeAllRanges();
          s.addRange(range);
        }
        textarea.setSelectionRange(0, 9999);
      } else {
        textarea.select();
      }
      document.execCommand("copy");
      div.removeChild(textarea);

      setTimeout(() => {
        this.copyTooltip = false;
      }, 1000);
    },
  },
};
</script>

<style scoped>
.titleText {
  text-align: left;
}

.copyIcon {
  -webkit-padding-start: 8px;
}

.imgQrcode {
  margin-top: 27px;
}
.qrUrl {
  max-width: 70%;
  overflow-x: auto;
  white-space: nowrap;
}

@media print {
  .qrUrl {
    overflow-x: none;
    white-space: normal;
  }
}
</style>
